import ShopCategoriesListListResultModelBase from '../_generated/modelBases/shop-categories-list-list-result-model-base';

export default class ShopCategoriesListListResultModel extends ShopCategoriesListListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
